export function getInitialsFromName(name: string) {
    const names = name.split(' ');
    return names
        .slice(0, 2)
        .map((n) => n.charAt(0))
        .join('')
        .toUpperCase();
}
